// import React, { useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { 
//   ArrowLeft,
//   Award,
//   Briefcase,
//   GraduationCap,
//   Calendar,
//   Clock,
//   MapPin,
//   Phone,
//   Mail,
//   CheckCircle,
//   Star,
//   Users,
//   Heart,
//   Activity,
//   Shield,
//   Stethoscope
// } from 'lucide-react';

// const DoctorDetailPage = () => {
//   const { doctorId } = useParams();
//   const [activeTab, setActiveTab] = useState('overview');

//   const doctorsData = {
//     'dr-naveen-chandra-tej': {
//       name: "Dr. P Naveen Chandra Tej",
//       image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=90",
//       specialty: "Interventional Cardiologist",
//       qualifications: "MBBS, MD, DM Cardiology (OSM)",
//       designation: "Consultant Interventional Cardiologist",
//       experience: "5+ Years",
//       currentHospital: "Zoi Hospitals, Attapur",
//       color: "#E86A33",
      
//       about: "Dr. Naveen C Tej is a consultant Interventional cardiologist currently working at Zoi hospitals, Attapur with over 5 years of experience. He specialises in complex interventional procedures and has extensive expertise in cardiac care.",
      
//       expertise: [
//         "Primary Percutaneous Coronary Intervention",
//         "Left Main Interventions",
//         "Bifurcation Stenting",
//         "Peripheral Interventions",
//         "Pericardiocentesis",
//         "Device Closure",
//         "Dual Chamber Pacemakers",
//         "Cardiac Resynchronization Therapy"
//       ],
      
//       experience_details: [
//         {
//           title: "Consultant Interventional Cardiologist",
//           hospital: "Zoi Hospitals, Attapur",
//           current: true
//         },
//         {
//           title: "Consultant Interventional Cardiologist",
//           hospital: "Renovo Hospital, Langer House"
//         },
//         {
//           title: "Consultant Interventional Cardiologist",
//           hospital: "Chavan Hospital, Balapur"
//         },
//         {
//           title: "Consultant",
//           hospital: "Viswa Bharati Hospital, Kurnool"
//         }
//       ],
      
//       services: [
//         "ECG",
//         "2D ECHO and Doppler - Adult/Paediatric",
//         "Holter Monitoring",
//         "Dobutamine Stress Echo"
//       ],
      
//       schedule: {
//         monday: "9:00 AM - 5:00 PM",
//         tuesday: "9:00 AM - 5:00 PM",
//         wednesday: "9:00 AM - 5:00 PM",
//         thursday: "9:00 AM - 5:00 PM",
//         friday: "9:00 AM - 5:00 PM",
//         saturday: "9:00 AM - 2:00 PM",
//         sunday: "Closed"
//       }
//     },
    
//     'dr-swathi-reddy-gadam': {
//       name: "Dr. Swathi Reddy Gadam",
//       image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=90",
//       specialty: "Obstetrician, Gynecologist & Infertility Specialist",
//       qualifications: "MBBS, MS (OBG), DNB, FMAS",
//       designation: "Consultant Obstetrician, Gynecologist & Laparoscopic Surgeon",
//       experience: "10+ Years",
//       currentHospital: "VAYU Lung Care",
//       color: "#FF9B6E",
      
//       about: "Dr. Swathi Reddy Gadam is a consultant obstetrician and gynecologist and laparoscopic surgeon and infertility specialist with over 10 years of experience. She has expertise in High risk pregnancy and does patient tailored treatment for various infertility problems.",
      
//       additionalQualifications: [
//         "Diploma in Advanced ART (Keil, Germany)",
//         "Fellowship in Infertility (IMA, Hyderabad)",
//         "Diploma in Cosmetic Gynaecology (Hyderabad)"
//       ],
      
//       expertise: [
//         "High Risk Pregnancy Care",
//         "Infertility Treatment",
//         "Laparoscopic Surgeries",
//         "Painless & Normal Delivery",
//         "Cesarean Section",
//         "Cervical Cerclage",
//         "Vaginal Hysterectomy"
//       ],
      
//       experience_details: [
//         {
//           title: "Consultant",
//           hospital: "VAYU Lung Care",
//           current: true
//         },
//         {
//           title: "Consultant",
//           hospital: "Sudha Fertility Center, Banjara Hills"
//         },
//         {
//           title: "Consultant",
//           hospital: "Muslim Maternity Hospital, Chadergat"
//         },
//         {
//           title: "Consultant",
//           hospital: "Ayan Medical College, Hyderabad"
//         },
//         {
//           title: "Consultant",
//           hospital: "Viswa Bharati Medical College, Kurnool"
//         }
//       ],
      
//       services: {
//         obstetrics: [
//           "Pre-conception Care and Counselling",
//           "Fertility Workup and Treatment",
//           "Antenatal Care",
//           "Painless and Normal Delivery",
//           "Cesarean Section",
//           "Cervical Cerclage",
//           "High Risk Pregnancy Care"
//         ],
//         gynaecology: [
//           "Laparoscopic Surgeries",
//           "Lap Tubectomy",
//           "Lap Hysterectomy",
//           "Lap Ovarian Cystectomy",
//           "Vaginal Hysterectomy",
//           "Abdominal Surgeries",
//           "Ectopic Pregnancy",
//           "Contraception",
//           "PCOS Treatment",
//           "Menstrual Irregularities",
//           "Menopausal Care"
//         ]
//       },
      
//       schedule: {
//         monday: "6:00 PM - 9:00 PM",
//         tuesday: "6:00 PM - 9:00 PM",
//         wednesday: "6:00 PM - 9:00 PM",
//         thursday: "6:00 PM - 9:00 PM",
//         friday: "6:00 PM - 9:00 PM",
//         saturday: "6:00 PM - 9:00 PM",
//         sunday: "10:00 AM - 12:00 PM"
//       }
//     },
    
//     'dr-sravan-kumar-yadav': {
//       name: "Dr. Sravan Kumar Yadav Todusu",
//       image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=90",
//       specialty: "Emergency Medicine Specialist",
//       qualifications: "DEM, MRCEM, FCD",
//       designation: "HOD - Department of Emergency Medicine",
//       experience: "10+ Years",
//       currentHospital: "Zoi Hospitals, Attapur",
//       color: "#2C85B8",
      
//       about: "Dr. Sravan Kumar Yadav is the Head of Department at Emergency Medicine with 10 years of experience in handling diabetic, hypertensive and other general health related patients. He was an active front line warrior during the COVID pandemic and has extensive ICU and ER experience.",
      
//       qualifications_full: [
//         "DEM (Diploma in Emergency Medicine)",
//         "MRCEM at Apollo Hospitals Hyderabad",
//         "FCD (Fellow in Clinical Diabetology) at IMA Hyderabad"
//       ],
      
//       expertise: [
//         "Emergency Medicine",
//         "Critical Care Management",
//         "Diabetic Patient Care",
//         "Hypertension Management",
//         "ICU Management",
//         "COVID-19 Care",
//         "General Health Care"
//       ],
      
//       experience_details: [
//         {
//           title: "HOD - Department of Emergency Medicine",
//           hospital: "Zoi Hospitals, Attapur",
//           current: true
//         },
//         {
//           title: "Consultant Emergency Medicine",
//           hospital: "Olive Hospital, Mehdipatnam"
//         },
//         {
//           title: "Consultant Emergency Medicine",
//           hospital: "OMNI Hospital, Kukatpally"
//         },
//         {
//           title: "ER & ICU Specialist",
//           hospital: "City Neuro Hospital, Banjara Hills"
//         },
//         {
//           title: "ER & ICU Specialist",
//           hospital: "Mahaveer Hospital, Mehdipatnam"
//         }
//       ],
      
//       achievements: [
//         "10 years of experience in Emergency Medicine",
//         "Active COVID-19 front line warrior",
//         "Saved numerous critical patients in ER and ICU",
//         "Expertise in handling diabetic and hypertensive emergencies",
//         "Known for kind and compassionate patient care"
//       ],
      
//       schedule: {
//         monday: "24/7 Emergency",
//         tuesday: "24/7 Emergency",
//         wednesday: "24/7 Emergency",
//         thursday: "24/7 Emergency",
//         friday: "24/7 Emergency",
//         saturday: "24/7 Emergency",
//         sunday: "24/7 Emergency"
//       }
//     }
//   };

//   const doctor = doctorsData[doctorId];

//   if (!doctor) {
//     return (
//       <div style={{padding: '4rem 2rem', textAlign: 'center', minHeight: '100vh'}}>
//         <h2>Doctor not found</h2>
//         <Link to="/#doctors" style={{color: '#E86A33'}}>Back to Doctors</Link>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Inter', sans-serif;
//           color: #1a1a1a;
//         }

//         .doctor-detail-page {
//           width: 100%;
//           min-height: 100vh;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//         }

//         /* Hero Section */
//         .doctor-hero {
//           position: relative;
//           height: 60vh;
//           min-height: 500px;
//           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
//           display: flex;
//           align-items: center;
//           overflow: hidden;
//         }

//         .doctor-hero::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           right: -20%;
//           width: 70%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(232, 106, 51, 0.15) 0%, transparent 70%);
//           animation: rotate 30s linear infinite;
//         }

//         @keyframes rotate {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }

//         .doctor-hero-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           width: 100%;
//           position: relative;
//           z-index: 2;
//         }

//         .back-link {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           color: white;
//           text-decoration: none;
//           font-weight: 600;
//           margin-bottom: 3rem;
//           padding: 0.8rem 1.5rem;
//           background: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(10px);
//           border-radius: 50px;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           transition: all 0.3s ease;
//         }

//         .back-link:hover {
//           background: rgba(255, 255, 255, 0.2);
//           transform: translateX(-5px);
//         }

//         .doctor-hero-grid {
//           display: grid;
//           grid-template-columns: 300px 1fr;
//           gap: 4rem;
//           align-items: center;
//         }

//         .doctor-image-large {
//           width: 300px;
//           height: 300px;
//           border-radius: 30px;
//           overflow: hidden;
//           border: 6px solid rgba(255, 255, 255, 0.2);
//           box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3);
//           position: relative;
//         }

//         .doctor-image-large img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .doctor-hero-info {
//           color: white;
//         }

//         .doctor-specialty-badge {
//           display: inline-block;
//           padding: 0.6rem 1.5rem;
//           background: rgba(255, 155, 110, 0.2);
//           border: 1px solid rgba(255, 155, 110, 0.4);
//           border-radius: 50px;
//           color: #FFD700;
//           font-size: 0.9rem;
//           font-weight: 700;
//           letter-spacing: 2px;
//           text-transform: uppercase;
//           margin-bottom: 1.5rem;
//         }

//         .doctor-name-large {
//           font-family: 'Playfair Display', serif;
//           font-size: 3.5rem;
//           font-weight: 900;
//           margin-bottom: 1rem;
//           line-height: 1.2;
//         }

//         .doctor-designation {
//           font-size: 1.3rem;
//           font-weight: 500;
//           opacity: 0.95;
//           margin-bottom: 2rem;
//         }

//         .doctor-quick-info {
//           display: flex;
//           gap: 3rem;
//           flex-wrap: wrap;
//         }

//         .quick-info-item {
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           font-size: 1.05rem;
//         }

//         /* Main Content */
//         .doctor-main-content {
//           max-width: 1400px;
//           margin: -100px auto 0;
//           padding: 0 2rem 6rem;
//           position: relative;
//           z-index: 10;
//         }

//         .content-wrapper {
//           display: grid;
//           grid-template-columns: 1fr 380px;
//           gap: 3rem;
//           align-items: start;
//         }

//         /* Tabs Navigation */
//         .tabs-navigation {
//           background: white;
//           border-radius: 25px;
//           padding: 1.5rem;
//           box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//         }

//         .tab-button {
//           padding: 1rem 2rem;
//           background: transparent;
//           border: 2px solid #e0e0e0;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 0.95rem;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           color: #666;
//         }

//         .tab-button.active {
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           border-color: #E86A33;
//           color: white;
//         }

//         .tab-button:hover:not(.active) {
//           border-color: #E86A33;
//           color: #E86A33;
//         }

//         /* Content Cards */
//         .content-card {
//           background: white;
//           border-radius: 25px;
//           padding: 3rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           margin-bottom: 2rem;
//         }

//         .card-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 2rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 2rem;
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .card-text {
//           font-size: 1.05rem;
//           line-height: 1.9;
//           color: #666;
//           margin-bottom: 2rem;
//         }

//         /* Expertise Grid */
//         .expertise-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 1rem;
//         }

//         .expertise-item {
//           display: flex;
//           align-items: flex-start;
//           gap: 1rem;
//           padding: 1.2rem;
//           background: #F8FAFB;
//           border-radius: 15px;
//           border-left: 4px solid #E86A33;
//           transition: all 0.3s ease;
//         }

//         .expertise-item:hover {
//           background: white;
//           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
//           transform: translateX(5px);
//         }

//         .expertise-icon {
//           color: #E86A33;
//           flex-shrink: 0;
//         }

//         .expertise-text {
//           font-size: 1rem;
//           font-weight: 600;
//           color: #1a1a1a;
//           line-height: 1.5;
//         }

//         /* Experience Timeline */
//         .experience-timeline {
//           position: relative;
//           padding-left: 3rem;
//         }

//         .experience-timeline::before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 0;
//           bottom: 0;
//           width: 3px;
//           background: linear-gradient(to bottom, #E86A33, #FF9B6E);
//         }

//         .timeline-item {
//           position: relative;
//           margin-bottom: 2.5rem;
//           padding: 1.5rem;
//           background: #F8FAFB;
//           border-radius: 15px;
//           transition: all 0.3s ease;
//         }

//         .timeline-item:hover {
//           background: white;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//         }

//         .timeline-item::before {
//           content: '';
//           position: absolute;
//           left: -3.5rem;
//           top: 2rem;
//           width: 16px;
//           height: 16px;
//           background: #E86A33;
//           border: 4px solid white;
//           border-radius: 50%;
//           box-shadow: 0 0 0 4px rgba(232, 106, 51, 0.2);
//         }

//         .timeline-item.current::before {
//           background: linear-gradient(135deg, #10b981, #059669);
//           box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2);
//           animation: pulse 2s ease-in-out infinite;
//         }

//         @keyframes pulse {
//           0%, 100% { box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2); }
//           50% { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.4); }
//         }

//         .timeline-badge {
//           display: inline-block;
//           padding: 0.4rem 1rem;
//           background: linear-gradient(135deg, #10b981, #059669);
//           color: white;
//           border-radius: 50px;
//           font-size: 0.75rem;
//           font-weight: 700;
//           text-transform: uppercase;
//           letter-spacing: 1px;
//           margin-bottom: 0.8rem;
//         }

//         .timeline-title {
//           font-size: 1.2rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 0.5rem;
//         }

//         .timeline-hospital {
//           font-size: 1rem;
//           color: #666;
//           font-weight: 500;
//         }

//         /* Services List */
//         .services-list {
//           display: grid;
//           gap: 2rem;
//         }

//         .service-category {
//           background: linear-gradient(135deg, #F8FAFB, white);
//           border-radius: 20px;
//           padding: 2rem;
//           border: 2px solid rgba(232, 106, 51, 0.1);
//         }

//         .service-category-title {
//           font-size: 1.5rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .service-items {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 1rem;
//         }

//         .service-item {
//           display: flex;
//           align-items: center;
//           gap: 0.8rem;
//           padding: 0.8rem;
//           background: white;
//           border-radius: 12px;
//           transition: all 0.3s ease;
//         }

//         .service-item:hover {
//           box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
//           transform: translateX(5px);
//         }

//         .service-icon {
//           width: 10px;
//           height: 10px;
//           background: #E86A33;
//           border-radius: 50%;
//           flex-shrink: 0;
//         }

//         .service-name {
//           font-size: 0.95rem;
//           color: #1a1a1a;
//           font-weight: 500;
//         }

//         /* Sidebar */
//         .sidebar {
//           position: sticky;
//           top: 120px;
//         }

//         .sidebar-card {
//           background: white;
//           border-radius: 25px;
//           padding: 2.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           margin-bottom: 2rem;
//         }

//         .sidebar-title {
//           font-size: 1.5rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .schedule-day {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 1rem 0;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .schedule-day:last-child {
//           border-bottom: none;
//         }

//         .day-name {
//           font-weight: 700;
//           color: #1B4965;
//           font-size: 0.95rem;
//         }

//         .day-time {
//           color: #666;
//           font-size: 0.9rem;
//           font-weight: 500;
//         }

//         .appointment-cta {
//           background: linear-gradient(135deg, #1B4965, #2C5F7C);
//           color: white;
//           text-align: center;
//           padding: 3rem 2rem;
//           border-radius: 25px;
//         }

//         .cta-title {
//           font-size: 1.8rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .cta-text {
//           font-size: 1rem;
//           opacity: 0.95;
//           margin-bottom: 2rem;
//           line-height: 1.7;
//         }

//         .cta-button {
//           padding: 1.2rem 3rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           display: inline-flex;
//           align-items: center;
//           gap: 0.8rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 6px 20px rgba(232, 106, 51, 0.4);
//           text-decoration: none;
//           width: 100%;
//           justify-content: center;
//         }

//         .cta-button:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 10px 30px rgba(232, 106, 51, 0.5);
//         }

//         .contact-info {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin-top: 2rem;
//         }

//         .contact-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 1rem;
//           background: rgba(255, 255, 255, 0.1);
//           border-radius: 12px;
//         }

//         .contact-item a {
//           color: white;
//           text-decoration: none;
//           font-weight: 500;
//         }

//         /* Responsive */
//         @media (max-width: 1200px) {
//           .content-wrapper {
//             gap: 2rem;
//           }
//         }

//         @media (max-width: 1024px) {
//           .doctor-hero-grid {
//             grid-template-columns: 1fr;
//             text-align: center;
//           }

//           .doctor-image-large {
//             margin: 0 auto 2rem;
//           }

//           .doctor-quick-info {
//             justify-content: center;
//           }

//           .content-wrapper {
//             grid-template-columns: 1fr;
//           }

//           .sidebar {
//             position: relative;
//             top: 0;
//           }
//         }

//         @media (max-width: 768px) {
//           .doctor-name-large {
//             font-size: 2.5rem;
//           }

//           .doctor-designation {
//             font-size: 1.1rem;
//           }

//           .content-card {
//             padding: 2rem;
//           }

//           .expertise-grid,
//           .service-items {
//             grid-template-columns: 1fr;
//           }

//           .tabs-navigation {
//             flex-direction: column;
//           }

//           .tab-button {
//             width: 100%;
//           }
//         }
//       `}</style>

//       <div className="doctor-detail-page">
//         {/* Hero Section */}
//         <section className="doctor-hero">
//           <div className="doctor-hero-content">
//             <Link to="/#doctors" className="back-link">
//               <ArrowLeft size={20} />
//               Back to Doctors
//             </Link>

//             <div className="doctor-hero-grid">
//               <div className="doctor-image-large">
//                 <img src={doctor.image} alt={doctor.name} />
//               </div>

//               <div className="doctor-hero-info">
//                 <div className="doctor-specialty-badge">{doctor.specialty}</div>
//                 <h1 className="doctor-name-large">{doctor.name}</h1>
//                 <p className="doctor-designation">{doctor.designation}</p>
                
//                 <div className="doctor-quick-info">
//                   <div className="quick-info-item">
//                     <GraduationCap size={24} />
//                     <span>{doctor.qualifications}</span>
//                   </div>
//                   <div className="quick-info-item">
//                     <Briefcase size={24} />
//                     <span>{doctor.experience}</span>
//                   </div>
//                   <div className="quick-info-item">
//                     <MapPin size={24} />
//                     <span>{doctor.currentHospital}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Main Content */}
//         <div className="doctor-main-content">
//           <div className="content-wrapper">
//             {/* Main Column */}
//             <div>
//               {/* Tabs */}
//               <div className="tabs-navigation">
//                 <button 
//                   className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('overview')}
//                 >
//                   Overview
//                 </button>
//                 <button 
//                   className={`tab-button ${activeTab === 'expertise' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('expertise')}
//                 >
//                   Expertise
//                 </button>
//                 <button 
//                   className={`tab-button ${activeTab === 'experience' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('experience')}
//                 >
//                   Experience
//                 </button>
//                 <button 
//                   className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('services')}
//                 >
//                   Services
//                 </button>
//               </div>

//               {/* Overview Tab */}
//               {activeTab === 'overview' && (
//                 <div className="content-card">
//                   <h2 className="card-title">
//                     <Activity size={32} />
//                     About {doctor.name.split(' ')[1]}
//                   </h2>
//                   <p className="card-text">{doctor.about}</p>

//                   {doctor.additionalQualifications && (
//                     <>
//                       <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#1B4965', marginTop: '2rem', marginBottom: '1rem'}}>
//                         Additional Qualifications
//                       </h3>
//                       <div className="expertise-grid">
//                         {doctor.additionalQualifications.map((qual, index) => (
//                           <div key={index} className="expertise-item">
//                             <Award size={20} className="expertise-icon" />
//                             <span className="expertise-text">{qual}</span>
//                           </div>
//                         ))}
//                       </div>
//                     </>
//                   )}

//                   {doctor.achievements && (
//                     <>
//                       <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#1B4965', marginTop: '2rem', marginBottom: '1rem'}}>
//                         Key Achievements
//                       </h3>
//                       <div className="expertise-grid">
//                         {doctor.achievements.map((achievement, index) => (
//                           <div key={index} className="expertise-item">
//                             <Star size={20} className="expertise-icon" />
//                             <span className="expertise-text">{achievement}</span>
//                           </div>
//                         ))}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               )}

//               {/* Expertise Tab */}
//               {activeTab === 'expertise' && (
//                 <div className="content-card">
//                   <h2 className="card-title">
//                     <Shield size={32} />
//                     Areas of Expertise
//                   </h2>
//                   <div className="expertise-grid">
//                     {doctor.expertise.map((item, index) => (
//                       <div key={index} className="expertise-item">
//                         <CheckCircle size={20} className="expertise-icon" />
//                         <span className="expertise-text">{item}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Experience Tab */}
//               {activeTab === 'experience' && (
//                 <div className="content-card">
//                   <h2 className="card-title">
//                     <Briefcase size={32} />
//                     Professional Experience
//                   </h2>
//                   <div className="experience-timeline">
//                     {doctor.experience_details.map((exp, index) => (
//                       <div key={index} className={`timeline-item ${exp.current ? 'current' : ''}`}>
//                         {exp.current && <div className="timeline-badge">Current</div>}
//                         <div className="timeline-title">{exp.title}</div>
//                         <div className="timeline-hospital">{exp.hospital}</div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Services Tab */}
//               {activeTab === 'services' && (
//                 <div className="content-card">
//                   <h2 className="card-title">
//                     <Stethoscope size={32} />
//                     Services Offered
//                   </h2>
//                   <div className="services-list">
//                     {doctor.services && !doctor.services.obstetrics && (
//                       <div className="service-items">
//                         {doctor.services.map((service, index) => (
//                           <div key={index} className="service-item">
//                             <div className="service-icon"></div>
//                             <span className="service-name">{service}</span>
//                           </div>
//                         ))}
//                       </div>
//                     )}

//                     {doctor.services && doctor.services.obstetrics && (
//                       <>
//                         <div className="service-category">
//                           <h3 className="service-category-title">Obstetrics Services</h3>
//                           <div className="service-items">
//                             {doctor.services.obstetrics.map((service, index) => (
//                               <div key={index} className="service-item">
//                                 <div className="service-icon"></div>
//                                 <span className="service-name">{service}</span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>

//                         <div className="service-category">
//                           <h3 className="service-category-title">Gynaecology Services</h3>
//                           <div className="service-items">
//                             {doctor.services.gynaecology.map((service, index) => (
//                               <div key={index} className="service-item">
//                                 <div className="service-icon"></div>
//                                 <span className="service-name">{service}</span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Sidebar */}
//             <div className="sidebar">
//               {/* Schedule Card */}
//               <div className="sidebar-card">
//                 <h3 className="sidebar-title">Consultation Hours</h3>
//                 {Object.entries(doctor.schedule).map(([day, time]) => (
//                   <div key={day} className="schedule-day">
//                     <span className="day-name">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
//                     <span className="day-time">{time}</span>
//                   </div>
//                 ))}
//               </div>

//               {/* Appointment CTA */}
//               <div className="sidebar-card appointment-cta">
//                 <h3 className="cta-title">Book an Appointment</h3>
//                 <p className="cta-text">
//                   Schedule your consultation with {doctor.name.split(' ')[1]} today
//                 </p>
//                 <a href="/contact" className="cta-button">
//                   Book Now
//                   <Calendar size={20} />
//                 </a>

//                 <div className="contact-info">
//                   <div className="contact-item">
//                     <Phone size={20} />
//                     <a href="tel:+911234567890">+91 123 456 7890</a>
//                   </div>
//                   <div className="contact-item">
//                     <Mail size={20} />
//                     <a href="mailto:appointments@vayulungcare.com">Book Online</a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DoctorDetailPage;


import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  ArrowLeft,
  Award,
  Briefcase,
  GraduationCap,
  Calendar,
  Clock,
  MapPin,
  Phone,
  Mail,
  CheckCircle,
  Star,
  Users,
  Heart,
  Activity,
  Shield,
  Stethoscope
} from 'lucide-react';
import doctor1 from '../Images/doctor1.jpeg';
import doctor2 from '../Images/doctor2.jpeg';
import doctor3 from '../Images/doctor3.jpeg';

const DoctorDetailPage = () => {
  const { doctorId } = useParams();
  const [activeTab, setActiveTab] = useState('overview');

  const doctorsData = {
    'dr-naveen-chandra-tej': {
      name: "Dr. P Naveen Chandra Tej",
      image: doctor2,
      specialty: "Interventional Cardiologist",
      qualifications: "MBBS, MD, DM Cardiology (OSM)",
      designation: "Consultant Interventional Cardiologist",
      experience: "5+ Years",
      currentHospital: "Zoi Hospitals, Attapur",
      color: "#E86A33",
      
      about: "Dr. Naveen C Tej is a consultant Interventional cardiologist currently working at Zoi hospitals, Attapur with over 5 years of experience. He specialises in complex interventional procedures and has extensive expertise in cardiac care.",
      
      expertise: [
        "Primary Percutaneous Coronary Intervention",
        "Left Main Interventions",
        "Bifurcation Stenting",
        "Peripheral Interventions",
        "Pericardiocentesis",
        "Device Closure",
        "Dual Chamber Pacemakers",
        "Cardiac Resynchronization Therapy"
      ],
      
      experience_details: [
        {
          title: "Consultant Interventional Cardiologist",
          hospital: "Zoi Hospitals, Attapur",
          current: true
        },
        {
          title: "Consultant Interventional Cardiologist",
          hospital: "Renovo Hospital, Langer House"
        },
        {
          title: "Consultant Interventional Cardiologist",
          hospital: "Chavan Hospital, Balapur"
        },
        {
          title: "Consultant",
          hospital: "Viswa Bharati Hospital, Kurnool"
        }
      ],
      
      services: [
        "ECG",
        "2D ECHO and Doppler - Adult/Paediatric",
        "Holter Monitoring",
        "Dobutamine Stress Echo"
      ],
      
      schedule: {
        monday: "9:00 AM - 5:00 PM",
        tuesday: "9:00 AM - 5:00 PM",
        wednesday: "9:00 AM - 5:00 PM",
        thursday: "9:00 AM - 5:00 PM",
        friday: "9:00 AM - 5:00 PM",
        saturday: "9:00 AM - 2:00 PM",
        sunday: "10:00 AM - 12:00 PM"
      }
    },
    
    'dr-swathi-reddy-gadam': {
      name: "Dr. Swathi Reddy Gadam",
      image: doctor1,
      specialty: "Obstetrician, Gynecologist & Infertility Specialist",
      qualifications: "MBBS, MS (OBG), DNB, FMAS",
      designation: "Consultant Obstetrician, Gynecologist & Laparoscopic Surgeon",
      experience: "10+ Years",
      currentHospital: "VAYU Lung Care",
      color: "#FF9B6E",
      
      about: "Dr. Swathi Reddy Gadam is a consultant obstetrician and gynecologist and laparoscopic surgeon and infertility specialist with over 10 years of experience. She has expertise in High risk pregnancy and does patient tailored treatment for various infertility problems.",
      
      additionalQualifications: [
        "Diploma in Advanced ART (Keil, Germany)",
        "Fellowship in Infertility (IMA, Hyderabad)",
        "Diploma in Cosmetic Gynaecology (Hyderabad)"
      ],
      
      expertise: [
        "High Risk Pregnancy Care",
        "Infertility Treatment",
        "Laparoscopic Surgeries",
        "Painless & Normal Delivery",
        "Cesarean Section",
        "Cervical Cerclage",
        "Vaginal Hysterectomy"
      ],
      
      experience_details: [
        {
          title: "Consultant",
          hospital: "VAYU Lung Care",
          current: true
        },
        {
          title: "Consultant",
          hospital: "Sudha Fertility Center, Banjara Hills"
        },
        {
          title: "Consultant",
          hospital: "Muslim Maternity Hospital, Chadergat"
        },
        {
          title: "Consultant",
          hospital: "Ayan Medical College, Hyderabad"
        },
        {
          title: "Consultant",
          hospital: "Viswa Bharati Medical College, Kurnool"
        }
      ],
      
      services: {
        obstetrics: [
          "Pre-conception Care and Counselling",
          "Fertility Workup and Treatment",
          "Antenatal Care",
          "Painless and Normal Delivery",
          "Cesarean Section",
          "Cervical Cerclage",
          "High Risk Pregnancy Care"
        ],
        gynaecology: [
          "Laparoscopic Surgeries",
          "Lap Tubectomy",
          "Lap Hysterectomy",
          "Lap Ovarian Cystectomy",
          "Vaginal Hysterectomy",
          "Abdominal Surgeries",
          "Ectopic Pregnancy",
          "Contraception",
          "PCOS Treatment",
          "Menstrual Irregularities",
          "Menopausal Care"
        ]
      },
      
      schedule: {
        monday: "9:00 PM - 9:00 PM",
        tuesday: "9:00 PM - 9:00 PM",
        wednesday: "9:00 PM - 9:00 PM",
        thursday: "9:00 PM - 9:00 PM",
        friday: "9:00 PM - 9:00 PM",
        saturday: "9:00 PM - 9:00 PM",
        sunday: "10:00 AM - 12:00 PM"
      }
    },
    
    'dr-sravan-kumar-yadav': {
      name: "Dr. Sravan Kumar Yadav Todusu",
      image: doctor3,
      specialty: "Emergency Medicine Specialist",
      qualifications: "DEM, MRCEM, FCD",
      designation: "HOD - Department of Emergency Medicine",
      experience: "10+ Years",
      currentHospital: "Zoi Hospitals, Attapur",
      color: "#2C85B8",
      
      about: "Dr. Sravan Kumar Yadav is the Head of Department at Emergency Medicine with 10 years of experience in handling diabetic, hypertensive and other general health related patients. He was an active front line warrior during the COVID pandemic and has extensive ICU and ER experience.",
      
      qualifications_full: [
        "DEM (Diploma in Emergency Medicine)",
        "MRCEM at Apollo Hospitals Hyderabad",
        "FCD (Fellow in Clinical Diabetology) at IMA Hyderabad"
      ],
      
      expertise: [
        "Emergency Medicine",
        "Critical Care Management",
        "Diabetic Patient Care",
        "Hypertension Management",
        "ICU Management",
        "COVID-19 Care",
        "General Health Care"
      ],
      
      experience_details: [
        {
          title: "HOD - Department of Emergency Medicine",
          hospital: "Zoi Hospitals, Attapur",
          current: true
        },
        {
          title: "Consultant Emergency Medicine",
          hospital: "Olive Hospital, Mehdipatnam"
        },
        {
          title: "Consultant Emergency Medicine",
          hospital: "OMNI Hospital, Kukatpally"
        },
        {
          title: "ER & ICU Specialist",
          hospital: "City Neuro Hospital, Banjara Hills"
        },
        {
          title: "ER & ICU Specialist",
          hospital: "Mahaveer Hospital, Mehdipatnam"
        }
      ],
      
      achievements: [
        "10 years of experience in Emergency Medicine",
        "Active COVID-19 front line warrior",
        "Saved numerous critical patients in ER and ICU",
        "Expertise in handling diabetic and hypertensive emergencies",
        "Known for kind and compassionate patient care"
      ],
      
         schedule: {
        monday: "9:00 PM - 9:00 PM",
        tuesday: "9:00 PM - 9:00 PM",
        wednesday: "9:00 PM - 9:00 PM",
        thursday: "9:00 PM - 9:00 PM",
        friday: "9:00 PM - 9:00 PM",
        saturday: "9:00 PM - 9:00 PM",
        sunday: "10:00 AM - 12:00 PM"
      }
    }
  };

  const doctor = doctorsData[doctorId];

  if (!doctor) {
    return (
      <div style={{padding: '4rem 2rem', textAlign: 'center', minHeight: '100vh'}}>
        <h2>Doctor not found</h2>
        <Link to="/#doctors" style={{color: '#E86A33'}}>Back to Doctors</Link>
      </div>
    );
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', sans-serif;
          color: #1a1a1a;
        }

        .doctor-detail-page {
          width: 100%;
          min-height: 100vh;
          background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
        }

        /* Hero Section */
        .doctor-hero {
          position: relative;
          height: 60vh;
          min-height: 500px;
          background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
          display: flex;
          align-items: center;
          overflow: hidden;
        }

        .doctor-hero::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 70%;
          height: 200%;
          background: radial-gradient(circle, rgba(232, 106, 51, 0.15) 0%, transparent 70%);
          animation: rotate 30s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .doctor-hero-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem;
          width: 100%;
          position: relative;
          z-index: 2;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          color: white;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 3rem;
          padding: 0.8rem 1.5rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .back-link:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateX(-5px);
        }

        .doctor-hero-grid {
          display: grid;
          grid-template-columns: 300px 1fr;
          gap: 4rem;
          align-items: center;
        }

        .doctor-image-large {
          width: 300px;
          height: 300px;
          border-radius: 30px;
          overflow: hidden;
          border: 6px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3);
          position: relative;
        }

        .doctor-image-large img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .doctor-hero-info {
          color: white;
        }

        .doctor-specialty-badge {
          display: inline-block;
          padding: 0.6rem 1.5rem;
          background: rgba(255, 155, 110, 0.2);
          border: 1px solid rgba(255, 155, 110, 0.4);
          border-radius: 50px;
          color: #FFD700;
          font-size: 0.9rem;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 1.5rem;
        }

        .doctor-name-large {
          font-family: 'Playfair Display', serif;
          font-size: 3.5rem;
          font-weight: 900;
          margin-bottom: 1rem;
          line-height: 1.2;
        }

        .doctor-designation {
          font-size: 1.3rem;
          font-weight: 500;
          opacity: 0.95;
          margin-bottom: 2rem;
        }

        .doctor-quick-info {
          display: flex;
          gap: 3rem;
          flex-wrap: wrap;
        }

        .quick-info-item {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          font-size: 1.05rem;
        }

        /* Main Content */
        .doctor-main-content {
          max-width: 1400px;
          margin: -100px auto 0;
          padding: 0 2rem 6rem;
          position: relative;
          z-index: 10;
        }

        .content-wrapper {
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 3rem;
          align-items: start;
        }

        /* Tabs Navigation */
        .tabs-navigation {
          background: white;
          border-radius: 25px;
          padding: 1.5rem;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
          margin-bottom: 2rem;
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .tab-button {
          padding: 1rem 2rem;
          background: transparent;
          border: 2px solid #e0e0e0;
          border-radius: 50px;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #666;
        }

        .tab-button.active {
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-color: #E86A33;
          color: white;
        }

        .tab-button:hover:not(.active) {
          border-color: #E86A33;
          color: #E86A33;
        }

        /* Content Cards */
        .content-card {
          background: white;
          border-radius: 25px;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          margin-bottom: 2rem;
        }

        .card-title {
          font-family: 'Playfair Display', serif;
          font-size: 2rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 2rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .card-text {
          font-size: 1.05rem;
          line-height: 1.9;
          color: #666;
          margin-bottom: 2rem;
        }

        /* Expertise Grid */
        .expertise-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
        }

        .expertise-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding: 1.2rem;
          background: #F8FAFB;
          border-radius: 15px;
          border-left: 4px solid #E86A33;
          transition: all 0.3s ease;
        }

        .expertise-item:hover {
          background: white;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          transform: translateX(5px);
        }

        .expertise-icon {
          color: #E86A33;
          flex-shrink: 0;
        }

        .expertise-text {
          font-size: 1rem;
          font-weight: 600;
          color: #1a1a1a;
          line-height: 1.5;
        }

        /* Experience Timeline */
        .experience-timeline {
          position: relative;
          padding-left: 3rem;
        }

        .experience-timeline::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(to bottom, #E86A33, #FF9B6E);
        }

        .timeline-item {
          position: relative;
          margin-bottom: 2.5rem;
          padding: 1.5rem;
          background: #F8FAFB;
          border-radius: 15px;
          transition: all 0.3s ease;
        }

        .timeline-item:hover {
          background: white;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .timeline-item::before {
          content: '';
          position: absolute;
          left: -3.5rem;
          top: 2rem;
          width: 16px;
          height: 16px;
          background: #E86A33;
          border: 4px solid white;
          border-radius: 50%;
          box-shadow: 0 0 0 4px rgba(232, 106, 51, 0.2);
        }

        .timeline-item.current::before {
          background: linear-gradient(135deg, #10b981, #059669);
          box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2);
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2); }
          50% { box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.4); }
        }

        .timeline-badge {
          display: inline-block;
          padding: 0.4rem 1rem;
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
          border-radius: 50px;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 0.8rem;
        }

        .timeline-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 0.5rem;
        }

        .timeline-hospital {
          font-size: 1rem;
          color: #666;
          font-weight: 500;
        }

        /* Services List */
        .services-list {
          display: grid;
          gap: 2rem;
        }

        .service-category {
          background: linear-gradient(135deg, #F8FAFB, white);
          border-radius: 20px;
          padding: 2rem;
          border: 2px solid rgba(232, 106, 51, 0.1);
        }

        .service-category-title {
          font-size: 1.5rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }

        .service-items {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
        }

        .service-item {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          padding: 0.8rem;
          background: white;
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        .service-item:hover {
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
          transform: translateX(5px);
        }

        .service-icon {
          width: 10px;
          height: 10px;
          background: #E86A33;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .service-name {
          font-size: 0.95rem;
          color: #1a1a1a;
          font-weight: 500;
        }

        /* Sidebar */
        .sidebar {
          position: sticky;
          top: 120px;
        }

        .sidebar-card {
          background: white;
          border-radius: 25px;
          padding: 2.5rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          margin-bottom: 2rem;
        }

        .sidebar-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }

        .schedule-day {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 0;
          border-bottom: 1px solid #f0f0f0;
        }

        .schedule-day:last-child {
          border-bottom: none;
        }

        .day-name {
          font-weight: 700;
          color: #1B4965;
          font-size: 0.95rem;
        }

        .day-time {
          color: #666;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .appointment-cta {
          background: linear-gradient(135deg, #1B4965, #2C5F7C);
          color: white;
          text-align: center;
          padding: 3rem 2rem;
          border-radius: 25px;
        }

        .cta-title {
          font-size: 1.8rem;
          font-weight: 800;
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .cta-text {
          font-size: 1rem;
          opacity: 0.95;
          margin-bottom: 2rem;
          line-height: 1.7;
        }

        .cta-button {
          padding: 1.2rem 3rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 0.8rem;
          transition: all 0.3s ease;
          box-shadow: 0 6px 20px rgba(232, 106, 51, 0.4);
          text-decoration: none;
          width: 100%;
          justify-content: center;
        }

        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(232, 106, 51, 0.5);
        }

        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 2rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
        }

        .contact-item a {
          color: white;
          text-decoration: none;
          font-weight: 500;
        }

        /* Responsive Breakpoints */
        @media (max-width: 1400px) {
          .doctor-hero-content,
          .doctor-main-content {
            padding-left: 2rem;
            padding-right: 2rem;
          }
        }

        @media (max-width: 1200px) {
          .content-wrapper {
            gap: 2rem;
          }

          .doctor-hero-grid {
            gap: 3rem;
          }

          .expertise-grid,
          .service-items {
            gap: 0.8rem;
          }
        }

        @media (max-width: 1024px) {
          .doctor-hero {
            height: auto;
            min-height: auto;
            padding: 4rem 0;
          }

          .doctor-hero-grid {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 2rem;
          }

          .doctor-image-large {
            margin: 0 auto 2rem;
            width: 250px;
            height: 250px;
          }

          .doctor-quick-info {
            justify-content: center;
            gap: 2rem;
          }

          .content-wrapper {
            grid-template-columns: 1fr;
          }

          .sidebar {
            position: relative;
            top: 0;
          }

          .doctor-main-content {
            margin-top: -60px;
          }

          .card-title {
            font-size: 1.8rem;
          }

          .sidebar-card {
            padding: 2rem;
          }
        }

        @media (max-width: 768px) {
          .doctor-hero-content,
          .doctor-main-content {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
          }

          .doctor-hero {
            padding: 3rem 0 2rem;
          }

          .back-link {
            padding: 0.6rem 1.2rem;
            font-size: 0.9rem;
            margin-bottom: 2rem;
          }

          .doctor-image-large {
            width: 200px;
            height: 200px;
            border-radius: 20px;
            border-width: 4px;
          }

          .doctor-specialty-badge {
            padding: 0.5rem 1.2rem;
            font-size: 0.75rem;
            letter-spacing: 1px;
          }

          .doctor-name-large {
            font-size: 2rem;
            margin-bottom: 0.8rem;
          }

          .doctor-designation {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }

          .doctor-quick-info {
            flex-direction: column;
            gap: 1rem;
          }

          .quick-info-item {
            font-size: 0.95rem;
          }

          .doctor-main-content {
            padding-bottom: 4rem;
            margin-top: -40px;
          }

          .content-card {
            padding: 1.5rem;
            border-radius: 20px;
            margin-bottom: 1.5rem;
          }

          .card-title {
            font-size: 1.5rem;
            margin-bottom: 1.5rem;
            gap: 0.8rem;
          }

          .card-title svg {
            width: 24px;
            height: 24px;
          }

          .card-text {
            font-size: 1rem;
            line-height: 1.7;
          }

          .expertise-grid,
          .service-items {
            grid-template-columns: 1fr;
            gap: 0.8rem;
          }

          .expertise-item {
            padding: 1rem;
            border-radius: 12px;
          }

          .expertise-text {
            font-size: 0.95rem;
          }

          .tabs-navigation {
            padding: 1rem;
            border-radius: 20px;
            gap: 0.8rem;
          }

          .tab-button {
            width: 100%;
            padding: 0.9rem 1.5rem;
            font-size: 0.9rem;
          }

          .experience-timeline {
            padding-left: 2rem;
          }

          .timeline-item {
            padding: 1.2rem;
            margin-bottom: 2rem;
          }

          .timeline-item::before {
            left: -2.5rem;
            width: 12px;
            height: 12px;
            border-width: 3px;
          }

          .timeline-badge {
            padding: 0.3rem 0.8rem;
            font-size: 0.7rem;
          }

          .timeline-title {
            font-size: 1.1rem;
          }

          .timeline-hospital {
            font-size: 0.95rem;
          }

          .service-category {
            padding: 1.5rem;
            border-radius: 15px;
          }

          .service-category-title {
            font-size: 1.3rem;
            margin-bottom: 1.2rem;
          }

          .service-item {
            padding: 0.7rem;
            border-radius: 10px;
          }

          .service-name {
            font-size: 0.9rem;
          }

          .sidebar-card {
            padding: 1.5rem;
            border-radius: 20px;
            margin-bottom: 1.5rem;
          }

          .sidebar-title {
            font-size: 1.3rem;
            margin-bottom: 1.2rem;
          }

          .schedule-day {
            padding: 0.8rem 0;
          }

          .day-name {
            font-size: 0.9rem;
          }

          .day-time {
            font-size: 0.85rem;
          }

          .appointment-cta {
            padding: 2rem 1.5rem;
            border-radius: 20px;
          }

          .cta-title {
            font-size: 1.5rem;
            margin-bottom: 0.8rem;
          }

          .cta-text {
            font-size: 0.95rem;
            margin-bottom: 1.5rem;
          }

          .cta-button {
            padding: 1rem 2rem;
            font-size: 0.95rem;
            gap: 0.6rem;
          }

          .contact-info {
            gap: 0.8rem;
            margin-top: 1.5rem;
          }

          .contact-item {
            padding: 0.8rem;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .doctor-hero-content,
          .doctor-main-content {
            padding-left: 1rem;
            padding-right: 1rem;
          }

          .doctor-hero {
            padding: 2rem 0 1.5rem;
          }

          .back-link {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
            margin-bottom: 1.5rem;
          }

          .doctor-image-large {
            width: 160px;
            height: 160px;
            border-radius: 15px;
          }

          .doctor-specialty-badge {
            padding: 0.4rem 1rem;
            font-size: 0.7rem;
            margin-bottom: 1rem;
          }

          .doctor-name-large {
            font-size: 1.6rem;
            line-height: 1.3;
          }

          .doctor-designation {
            font-size: 0.9rem;
            margin-bottom: 1.2rem;
          }

          .quick-info-item {
            font-size: 0.85rem;
          }

          .quick-info-item svg {
            width: 18px;
            height: 18px;
          }

          .doctor-main-content {
            margin-top: -30px;
            padding-bottom: 3rem;
          }

          .content-card {
            padding: 1.2rem;
            border-radius: 15px;
          }

          .card-title {
            font-size: 1.3rem;
            margin-bottom: 1.2rem;
            flex-wrap: wrap;
          }

          .card-title svg {
            width: 20px;
            height: 20px;
          }

          .card-text {
            font-size: 0.95rem;
            line-height: 1.6;
            margin-bottom: 1.5rem;
          }

          .expertise-item {
            padding: 0.8rem;
            gap: 0.8rem;
          }

          .expertise-icon {
            width: 16px;
            height: 16px;
          }

          .expertise-text {
            font-size: 0.9rem;
          }

          .tabs-navigation {
            padding: 0.8rem;
            border-radius: 15px;
            margin-bottom: 1.5rem;
          }

          .tab-button {
            padding: 0.8rem 1.2rem;
            font-size: 0.85rem;
            border-radius: 40px;
          }

          .experience-timeline {
            padding-left: 1.5rem;
          }

          .timeline-item {
            padding: 1rem;
            margin-bottom: 1.5rem;
            border-radius: 12px;
          }

          .timeline-item::before {
            left: -2rem;
            width: 10px;
            height: 10px;
          }

          .timeline-title {
            font-size: 1rem;
          }

          .timeline-hospital {
            font-size: 0.9rem;
          }

          .service-category {
            padding: 1.2rem;
            border-radius: 12px;
          }

          .service-category-title {
            font-size: 1.2rem;
            margin-bottom: 1rem;
          }

          .service-item {
            padding: 0.6rem;
          }

          .service-name {
            font-size: 0.85rem;
          }

          .sidebar-card {
            padding: 1.2rem;
            border-radius: 15px;
          }

          .sidebar-title {
            font-size: 1.2rem;
            margin-bottom: 1rem;
          }

          .schedule-day {
            padding: 0.7rem 0;
            flex-direction: column;
            align-items: flex-start;
            gap: 0.3rem;
          }

          .day-name,
          .day-time {
            font-size: 0.85rem;
          }

          .appointment-cta {
            padding: 1.5rem 1.2rem;
            border-radius: 15px;
          }

          .cta-title {
            font-size: 1.3rem;
            line-height: 1.3;
          }

          .cta-text {
            font-size: 0.9rem;
            line-height: 1.6;
          }

          .cta-button {
            padding: 0.9rem 1.5rem;
            font-size: 0.9rem;
          }

          .contact-item {
            padding: 0.7rem;
            font-size: 0.85rem;
          }

          .contact-item svg {
            width: 16px;
            height: 16px;
          }
        }

        @media (max-width: 360px) {
          .doctor-name-large {
            font-size: 1.4rem;
          }

          .doctor-image-large {
            width: 140px;
            height: 140px;
          }

          .card-title {
            font-size: 1.2rem;
          }

          .tabs-navigation {
            gap: 0.6rem;
          }

          .tab-button {
            padding: 0.7rem 1rem;
            font-size: 0.8rem;
          }
        }
      `}</style>

      <div className="doctor-detail-page">
        {/* Hero Section */}
        <section className="doctor-hero">
          <div className="doctor-hero-content">
            <Link to="/#doctors" className="back-link">
              <ArrowLeft size={20} />
              Back to Doctors
            </Link>

            <div className="doctor-hero-grid">
              <div className="doctor-image-large">
                <img src={doctor.image} alt={doctor.name} />
              </div>

              <div className="doctor-hero-info">
                <div className="doctor-specialty-badge">{doctor.specialty}</div>
                <h1 className="doctor-name-large">{doctor.name}</h1>
                <p className="doctor-designation">{doctor.designation}</p>
                
                <div className="doctor-quick-info">
                  <div className="quick-info-item">
                    <GraduationCap size={24} />
                    <span>{doctor.qualifications}</span>
                  </div>
                  <div className="quick-info-item">
                    <Briefcase size={24} />
                    <span>{doctor.experience}</span>
                  </div>
                  <div className="quick-info-item">
                    <MapPin size={24} />
                    <span>{doctor.currentHospital}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <div className="doctor-main-content">
          <div className="content-wrapper">
            {/* Main Column */}
            <div>
              {/* Tabs */}
              <div className="tabs-navigation">
                <button 
                  className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
                  onClick={() => setActiveTab('overview')}
                >
                  Overview
                </button>
                <button 
                  className={`tab-button ${activeTab === 'expertise' ? 'active' : ''}`}
                  onClick={() => setActiveTab('expertise')}
                >
                  Expertise
                </button>
                <button 
                  className={`tab-button ${activeTab === 'experience' ? 'active' : ''}`}
                  onClick={() => setActiveTab('experience')}
                >
                  Experience
                </button>
                <button 
                  className={`tab-button ${activeTab === 'services' ? 'active' : ''}`}
                  onClick={() => setActiveTab('services')}
                >
                  Services
                </button>
              </div>

              {/* Overview Tab */}
              {activeTab === 'overview' && (
                <div className="content-card">
                  <h2 className="card-title">
                    <Activity size={32} />
                    About {doctor.name.split(' ')[1]}
                  </h2>
                  <p className="card-text">{doctor.about}</p>

                  {doctor.additionalQualifications && (
                    <>
                      <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#1B4965', marginTop: '2rem', marginBottom: '1rem'}}>
                        Additional Qualifications
                      </h3>
                      <div className="expertise-grid">
                        {doctor.additionalQualifications.map((qual, index) => (
                          <div key={index} className="expertise-item">
                            <Award size={20} className="expertise-icon" />
                            <span className="expertise-text">{qual}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {doctor.achievements && (
                    <>
                      <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#1B4965', marginTop: '2rem', marginBottom: '1rem'}}>
                        Key Achievements
                      </h3>
                      <div className="expertise-grid">
                        {doctor.achievements.map((achievement, index) => (
                          <div key={index} className="expertise-item">
                            <Star size={20} className="expertise-icon" />
                            <span className="expertise-text">{achievement}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Expertise Tab */}
              {activeTab === 'expertise' && (
                <div className="content-card">
                  <h2 className="card-title">
                    <Shield size={32} />
                    Areas of Expertise
                  </h2>
                  <div className="expertise-grid">
                    {doctor.expertise.map((item, index) => (
                      <div key={index} className="expertise-item">
                        <CheckCircle size={20} className="expertise-icon" />
                        <span className="expertise-text">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Experience Tab */}
              {activeTab === 'experience' && (
                <div className="content-card">
                  <h2 className="card-title">
                    <Briefcase size={32} />
                    Professional Experience
                  </h2>
                  <div className="experience-timeline">
                    {doctor.experience_details.map((exp, index) => (
                      <div key={index} className={`timeline-item ${exp.current ? 'current' : ''}`}>
                        {exp.current && <div className="timeline-badge">Current</div>}
                        <div className="timeline-title">{exp.title}</div>
                        <div className="timeline-hospital">{exp.hospital}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Services Tab */}
              {activeTab === 'services' && (
                <div className="content-card">
                  <h2 className="card-title">
                    <Stethoscope size={32} />
                    Services Offered
                  </h2>
                  <div className="services-list">
                    {doctor.services && !doctor.services.obstetrics && (
                      <div className="service-items">
                        {doctor.services.map((service, index) => (
                          <div key={index} className="service-item">
                            <div className="service-icon"></div>
                            <span className="service-name">{service}</span>
                          </div>
                        ))}
                      </div>
                    )}

                    {doctor.services && doctor.services.obstetrics && (
                      <>
                        <div className="service-category">
                          <h3 className="service-category-title">Obstetrics Services</h3>
                          <div className="service-items">
                            {doctor.services.obstetrics.map((service, index) => (
                              <div key={index} className="service-item">
                                <div className="service-icon"></div>
                                <span className="service-name">{service}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="service-category">
                          <h3 className="service-category-title">Gynaecology Services</h3>
                          <div className="service-items">
                            {doctor.services.gynaecology.map((service, index) => (
                              <div key={index} className="service-item">
                                <div className="service-icon"></div>
                                <span className="service-name">{service}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Sidebar */}
            <div className="sidebar">
              {/* Schedule Card */}
              <div className="sidebar-card">
                <h3 className="sidebar-title">Consultation Hours</h3>
                {Object.entries(doctor.schedule).map(([day, time]) => (
                  <div key={day} className="schedule-day">
                    <span className="day-name">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                    <span className="day-time">{time}</span>
                  </div>
                ))}
              </div>

              {/* Appointment CTA */}
              <div className="sidebar-card appointment-cta">
                <h3 className="cta-title">Book an Appointment</h3>
                <p className="cta-text">
                  Schedule your consultation with {doctor.name.split(' ')[1]} today
                </p>
                <a href="/contact" className="cta-button">
                  Book Now
                  <Calendar size={20} />
                </a>

                <div className="contact-info">
                  <div className="contact-item">
                    <Phone size={20} />
                    <a href="tel:+919989162222">9989162222</a>
                  </div>
                  <div className="contact-item">
                    <Mail size={20} />
                    <a href="mailto:appointments@vayulungcare.com">Book Online</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorDetailPage;